import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Select } from 'antd';
import { CollectionServer, CollectionServerMobile, deleteInArray, errorCatch, GET, GETWITH, If, Model, QueryParam, updateInArray, useAuth } from 'fennec-ui';

import React, { } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { getShkolaFromRoles } from '../../../../common/Tool';
import User from '../../../../common/User';
import PageLayout from '../../../components/PageLayout';
import { useBreadcrumbs, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext, useSchoolContext } from '../../../../common/Context';
import CapsuleMenu from '../../../components/CapsuleMenu';
import TabsMenu from '../../../components/TabsMenu';

const { Option } = Select;

const useStyles = createUseStyles({
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
    },
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function SchoolEducationStudents(props) {
    const [ctx, setSchool] = useSchoolContext();
    const classes = useStyles();
    const auth = useAuth();
    const dispatch = useDispatch();

    const sourceKey = "school";

    const filters = () => [
        {
            label: "Фамилия",
            name: "vtp.user.lastname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Имя",
            name: "vtp.user.firstname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Отчество",
            name: "vtp.user.patronymic",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Email",
            name: "vtp.user.email",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "vtp.user.phone",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Дата рождения",
            name: "vtp.user.birthday",
            type: "date",
            filterType: "range",
            // func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Дата регистрации",
            name: "vtp.dataZapisi",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
        },
        {
            label: "Дата подтверждения",
            name: "vtp.dataPodtverzhdeniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
        },
        {
            label: "Подтверждение",
            name: "vtp.dokumentPodtverzhdeniya.ID",
            // display: (o) => o.nazvanie,
            type: "bool",
            sort: true,
            // filter: true,
        },
        {
            name: "osnovnaya",
            sort: true,
            filter: true,
            label: "Основная школа",
            type: "object",
            relation: {
                display: (item) => {
                    return item.name
                },
                reference: {
                    data: [
                        { ID: 1, name: "Да" },
                        { ID: 2, name: "Нет" },
                    ]
                },
                type: "many-one",
            },
            queryRaw: (value, item, key) => {
                if (value == 2) {
                    return QueryParam("w-eq-" + key, "false")
                } else if (value == 1) {
                    return QueryParam("w-eq-" + key, "true")
                }
                return ""
            }
        },
    ];

    // ----------------------------------------
    const breadcrumbs = useBreadcrumbs()
    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if (count >= i) return p;
            if (!arr[idx]?.context) {
                count++
            }
            p += `/${arr[idx]?.uuid}`
        }
        return p
    }
    // ----------------------------------------

    return (<div className="subcontent">
        <div className={"content"}>
            <PageLayout hideSider={true} hideBreadcrumbs={true}>
                <div style={{ height: "100%", overflowY: "auto", backgroundColor: "white", borderRadius: "4px", padding: "10px" }}>

                    <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} />

                    <div style={{ fontSize: "14px", paddingTop: "15px" }}>
                        {"Ученики школы"}
                    </div>
                    <div style={{ fontSize: "20px" }}>
                        {((ctx) ? ctx.nazvanieShkoliTantsev : "")}
                    </div>

                    {ctx && <CollectionServerMobile
                        noheader={true}
                        // title={"Ученики школы " + ((ctx) ? "\"" + ctx.nazvanieShkoliTantsev + "\"" : "")}
                        name={"UchenikiShkol"}
                        auth={auth}
                        size="small"
                        source={`/api/school/uchenikishkoli/list/${ctx?.ID}`}
                        filters={filters}
                        // contextFilters={((active && notactive) || (!active && !notactive)) ? undefined : () => [
                        //     If(notactive, QueryParam("w-nu-vtp.dokumentPodtverzhdeniya.ID", "")),
                        //     If(active, QueryParam("w-nnu-vtp.dokumentPodtverzhdeniya.ID", "")),
                        // ]}
                        mode={"list"}
                        render={(item, idx, { setCollection, setCollectionItem, update }) => {
                            return (<div key={idx} style={{ width: "100%" }} className="students">
                                <div className={classes.item}>
                                    <div style={{ flex: "auto" }}>
                                        <User item={item.vtp.user} noborder={true} />
                                        {(item?.osnovnaya !== true && item?.vtp?.dokumentPodtverzhdeniyaID) && <div style={{ fontSize: '12px', color: "red" }}>Школа не основная для ученика!</div>}
                                        {(!item?.vtp?.dokumentPodtverzhdeniyaID) && <div style={{ fontSize: '13px', color: "orange" }}>Ожидает подтверждения школой!</div>}
                                    </div>
                                </div>
                            </div>)
                        }}
                        // collectionActions={() => [
                        //     {
                        //         action: (values, unlock, close, { collection, setCollection }) => {
                        //             GET(auth, `/api/eventuser/presenter/add/${object.ID}/${values.polzovatel.ID}`,
                        //                 ({ data }) => {
                        //                     setCollection(updateInArray(collection, data));
                        //                     close();
                        //                 }, errorCatch
                        //             );
                        //         },
                        //         form: AddControllerMeropriyatie,
                        //         options: {
                        //             initialValues: {},
                        //         },
                        //         title: "Добавить ученика",
                        //         modal: {
                        //             minWidth: "250px",
                        //             title: "Новый ученик",
                        //         }
                        //     }
                        // ]}
                        modelActions={(item) => [
                            If(!item?.vtp?.dokumentPodtverzhdeniyaID, {
                                title: "Подтвердить",
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    GET(auth, `/api/school/uchenikshkoli/podtverditregistratsiuuchenikaschool/admin/${item.vtp.ID}`,
                                        ({ data }) => {
                                            // let v = _.set(item, "vtp.dokumentPodtverzhdeniyaID", Number.MAX_SAFE_INTEGER)
                                            setCollection(updateInArray(collection, data));
                                        }, errorCatch);
                                },
                            }),
                            If(!item?.vtp?.dokumentPodtverzhdeniyaID, {
                                title: "Отказать",
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    Modal.confirm({
                                        title: `Вы уверены что хотите отказать ученику в добавлении его в школу?`,
                                        icon: <ExclamationCircleOutlined />,
                                        content: <User item={item.vtp.user} noborder={true} />,
                                        okText: "Да, отказать",
                                        okType: 'danger',
                                        cancelText: "Нет",
                                        onOk: () => {
                                            GET(auth, `/api/school/uchenikshkoli/otkazregistratsiiuchenikaschool/admin/${item.vtp.ID}`,
                                                () => {
                                                    setCollection(deleteInArray(collection, item));
                                                }, errorCatch);
                                        },
                                        onCancel: unlock
                                    });
                                },
                            }),
                            {
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                modal: {
                                    title: "Удалить ученика школы?"
                                },
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    // console.log(values);
                                    Modal.confirm({
                                        title: `Вы уверены что хотите удалить ученика${(values.blacklist) ? " и добавить его в черный список" : ""}?`,
                                        icon: <ExclamationCircleOutlined />,
                                        content: <User item={item.vtp.user} noborder={true} />,
                                        okText: "Да",
                                        okType: 'danger',
                                        cancelText: "Нет",
                                        onOk: () => {
                                            GETWITH(auth, `/api/delete/school/uchenikshkoli/admin/${item.ID}`, [
                                                QueryParam("blacklist", values.blacklist)
                                            ], () => {
                                                setCollection(deleteInArray(collection, item));
                                                close();
                                            }, (err) => errorCatch(err, unlock));
                                        },
                                        onCancel: unlock
                                    });
                                },
                                okText: "Удалить",
                                dismissText: "Отмена",
                                form: Model,
                                meta: [
                                    {
                                        type: "func",
                                        render: (auth, _item) => (<div style={{ paddingBottom: "5px" }}>
                                            <User item={item.vtp.user} noborder={true} />
                                        </div>)
                                    },
                                    {
                                        label: "Добавить в черный список",
                                        name: "blacklist",
                                        type: "bool",
                                    },
                                ],
                            },
                        ]}
                    />}
                </div>
            </PageLayout>
        </div>
        <div className={"footer"}>
            <CapsuleMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} />

            {/* <TabsMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} /> */}
            {/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}

        </div>
    </div>)
}
